import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

const VerificationSessionListSkeleton: React.FC = () => (
  <Card>
    <CardContent className="p-6">
      <div className="mb-4">
        <Skeleton className="h-10 w-full rounded-md" />
      </div>
      {[1, 2, 3].map((i) => (
        <div key={i} className="mb-2">
          <Skeleton className="h-[72px] w-full rounded-md" />
        </div>
      ))}
    </CardContent>
  </Card>
);

export default VerificationSessionListSkeleton;
